import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { LanguageSelectorModel } from '../model/language-selector.model';
import { LANGUAGES } from '../language-selector-data';


@Injectable({
  providedIn: 'root'
})
export class LanguageSelectorService {
  private defaultLang: LanguageSelectorModel = {
    code: 'en',
    name: 'English',
    flag: 'https://flagcdn.com/w20/us.png'
  };

  private languageSubject = new BehaviorSubject<LanguageSelectorModel>(this.defaultLang);
  language$ = this.languageSubject.asObservable();

  setLanguage(lang: LanguageSelectorModel): void {
    this.languageSubject.next(lang);
  }

  getCurrentLanguage(): LanguageSelectorModel {
    return this.languageSubject.value;
  }

  getAvailableLanguages(): LanguageSelectorModel[] {
    return LANGUAGES;
  }

  changeLanguage(language: string): void {
    const selectedLanguage = LANGUAGES.find(lang => lang.code === language);
    if (selectedLanguage) {
      this.languageSubject.next(selectedLanguage);
    } else {
      console.error(`Language with code "${language}" not found.`);
    }
  }
}
